import { SystemService } from "./SystemService";
import AuthService from "./AuthService";

class UsersService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getUsers(filters = {}) {
        let sessionid = this.authService.getSessionId();
        const params = {};
        if (filters.search && filters.search.trim() !== '') params.search = filters.search.trim();
        if (filters.role && filters.role !== 'all' && filters.role.trim() !== '') params.role = filters.role.trim();
        if (filters.manager && filters.manager !== 'all' && filters.manager.trim() !== '') params.manager = filters.manager.trim();
        if (filters.page) params.page = filters.page;
        if (filters.limit) params.limit = filters.limit;

        return new Promise((resolve, reject) => {
            this.api.get('auth/getUsers', { 
                headers: { authorization: sessionid },
                params
            }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.response ? e.response.data.message : e.message);
            });
        });
    }

    createUser(user) {
        let sessionid = this.authService.getSessionId();
        return new Promise((resolve, reject) => {
            this.api.post('auth/createUser', user, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.response ? e.response.data.message : e.message);
            });
        });
    }

    updateUser(user) {
        let sessionid = this.authService.getSessionId();
        return new Promise((resolve, reject) => {
            this.api.post('auth/updateUser', user, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.response ? e.response.data.message : e.message);
            });
        });
    }

    changePassword(userId, password, mustChangePassword = false) {
        let sessionid = this.authService.getSessionId();
        return new Promise((resolve, reject) => {
            this.api.post('auth/updateUser', { userId, password, mustChangePassword }, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.response ? e.response.data.message : e.message);
            });
        });
    }

    syncEmployees() {
        let sessionid = this.authService.getSessionId();
        return new Promise((resolve, reject) => {
            this.api.post('auth/syncEmployees', {}, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.response ? e.response.data.message : e.message);
            });
        });
    }
}

export default UsersService;
